import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, of, switchMap, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LocalStorageService } from './local-storage.service';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private _authenticated: boolean = false;

  constructor(
    private http: HttpClient, 
    private _storage: LocalStorageService, 
    private _userService: UserService
  ) { }

  /**
 * Setter & getter for access token
 */
  set accessToken(token: any)
  {
      this._storage.setToken(token);
  }

  get accessToken(): any
  {
      return this._storage.getToken();
  }



  signUp( userRegisterData: string ): Observable<any>
  {
      return  this.http.post(`${environment.API_BASE_URL}api/v1/user/signup`,userRegisterData ).pipe(
       switchMap((response: any) => {          
           // Store the access token in the local storage
           this.accessToken = response.data.session.session_token
           this._storage.storeData('userId',response.data.session.user_id);
           this._storage.storeData('walletAddress',response.data.user.wallet_address);
           this._storage.storeData('userDetails', response.data);
           this._storage.storeData('userProfile', { user: response.data.user });
           // localStorage.setItem('user_id',response.data.session.user_id)
           // this.accessToken()
           // Set the authenticated flag to true
           this._authenticated = true;

           // Store the user on the user service
           this._userService.user = response.user;           

           // Return a new observable with the response
           return of(response);
       }),
       catchError((err) => {
           return throwError(err)
       })
   )
  }

  signin(payload: any): Observable<any>
  {
   const user =
     typeof payload === 'string'
       ? { wallet_address: payload }
       : payload;
      return  this.http.post(`${environment.API_BASE_URL}api/v1/user/login`,user ).pipe(
       switchMap((response: any) => {           
           // Store the access token in the local storage
           this.accessToken = response.data.session.session_token
           this._storage.storeData('userId',response.data.session.user_id);
           this._storage.storeData('walletAddress', response.data.user.wallet_address);
           this._storage.storeData('userDetails', response.data);
           this._storage.storeData('userProfile', { user: response.data.user });
           // localStorage.setItem('user_id',response.data.session.user_id)
           // localStorage.setItem('accessToken', response.data.session.session_token);

           // this.accessToken()
           // Set the authenticated flag to true
           this._authenticated = true;

           // Store the user on the user service
           this._userService.user = response.user;

           // Return a new observable with the response
           return of(response);
       })
   );;
  }

  /**
* Gets user
* @param walletAddress 
* @returns  
*/
  public getUser(walletAddress:any){    
    return this.http.get(`${environment.API_BASE_URL}api/v1/user/check-user/${walletAddress}`);
  }

  /**
   * Logouts user
   * @returns  
   */
  public logoutUser() {
    return this.http.delete(`${environment.API_BASE_URL}api/v1/user/logout`);
  }

  /**
   * Coinbits api
   * @returns  
   */
  public coinbitApi() {
    return this.http.get(`${environment.COINBIT_API_BASE_URL}/public/markets`);
  }

  /**
   * Visitors count
   * @returns  
   */
  public visitorsCount() {
    return this.http.patch(`${environment.API_BASE_URL}api/v1/user/visitor-count`,{})
  }

  /**
   * Gets phase by type
   * @param type 
   * @returns  
   */
  public getPhaseByType(type: number) {
    return this.http.get(`${environment.API_BASE_URL}api/v1/user/get-phase-by-type/?phase=${type}`);
  }

  /**
   * Announcements list
   * @returns  
   */
  public announcementList() {
    return this.http.get(`${environment.API_BASE_URL}api/v1/user/list-announcement`);
  }


  /**
   * Sign up a user with the given userRegisterData.
   * It will call the API to signup a user and store the access token in the local storage.
   * It will set the authenticated flag to true.
   * It will store the user on the user service.
   * It will return a new observable with the response.
   * @param userRegisterData The data for creating the user.
   * @returns Observable<any> The response from the API.
   */
  collaborativeSignUp( userRegisterData: string ): Observable<any>
  {
      return  this.http.post(`${environment.API_BASE_URL}api/v1/user/collaborator-signup`,userRegisterData ).pipe(
       switchMap((response: any) => {          
           // Store the access token in the local storage
           this.accessToken = response.data.session.session_token
           this._storage.storeData('userId',response.data.session.user_id);
           this._storage.storeData('walletAddress',response.data.user.wallet_address);
           this._storage.storeData('userDetails', response.data);
           this._storage.storeData('userProfile', { user: response.data.user });
           this._authenticated = true;
           // Store the user on the user service
           this._userService.user = response.user;  
           // Return a new observable with the response
           return of(response);
       }),
       catchError((err) => {
           return throwError(err)
       })
   )
  }


  isValidCollaborator(id: string): Observable<any> {
    return this.http.get<any>(`${environment.API_BASE_URL}api/v1/user/check-invalid-collaborative/${id}`);
  }

}
